<template>
  <div>
    <div v-if="has_map">
      <div class="col-4 holder-left">
        <div v-for="hour in op_hours" :key="hour.hour" class="hour-block">
          {{hour.text}}
        </div>
      </div>
      <div class="col-8 holder-right">
        <div v-for="block in cal_blocks" :key="block.start_time" :title="getDesc(block)" class="tblock" @mouseenter="callBack(block)" :style="computedStyle(block)" @click="callBack(block)" >
          
        </div>
      </div>
    </div>
    <div v-if="!has_map" class="col-12">
      <font-awesome-icon class="m-auto" style="width:50px;height:50px;" fixed-width :icon="['fas','question']" />
      <div>該日期未設定開放營業</div>
    </div>

  </div>
</template>

<script>

/*
  被配置的col-md-6的組件
  內容物是左右兩邊的圖示,左為時間刻度 右邊則是一個區塊根據累積劃位數顯示深淺顏色
  複雜處在左邊時間刻度和右邊時段區塊的定位要對齊,左邊是固定的,右邊是動態的

  先產生左邊div,高度根據日營業時間起訖(res_map第一筆與最後一筆)的小時決定 有幾個小時 高度動態算出來
  左邊就每一個小時一格依序往下畫到底
  右邊則是要先用res_map產生一個補滿的時段陣列(開始時間非整點要補一塊,結束時間非整點要補一塊,中間遇休息時段中斷也要補滿)
  右邊用補滿的時段陣列逐時段render,且每個時段click要觸發事件把store_possible_reserve_time_id與起訖時間帶回去,供外部組件由劃位紀錄篩選對應劃位動態顯示
  這一段處理拉到上層組件做,只接收結果做單純的render就好(好方便上層組件利用計算結果的數據串其他組件)

  增加highlight_from_time與to_time,預設undefined或空字串,均不做任何處理
  如果起訖時間都有設置,則

*/
export default {
  name: 'StoreRcView',
  props: {
    'op_hours':Array,
    'cal_blocks':Array,
    'has_map':Boolean,
    'block_clicked': {
      type:Function,
      default: (block,vm)=> {
        vm.$bus.fnShowInfo(vm.getDesc(block))
      }
    }
  },
  data: function () {
    return {
      
    }
  },
  methods: {
    callBack(block) {
      this.block_clicked(block, this)
    },
    getDesc(block) {
      return this.getPartFromDatetimeStr(block.start_time,'hourminute')+ "自動接受劃位:"+block.auto_accept_count+" 時段當前劃位累積人次："+block.overlays
    },
    computedStyle(block) {
      // 顏色的配置是深淺漸層,但為了讓前兩三個數值較突出,所以用寫死的規則而不用公式套
      let color = 'fff'
      if (block.id) {
        switch (block.overlays) {
          case 0:
            // 極淡紅：營業時間未被劃位
            // color = 'fffafa'
            color = 'fafaff'
            break
          case 1:
            // 看得出來的淡紅,被劃位一人次...後續漸次加深
            // color = 'ffe6e6'
            color = 'e6ecff'
            break
          case 2:
            // color = 'ffcccc'
            color = 'ccccff'
            break
          case 3:
            // color = 'ff9999'
            color = '9999ff'
            break
          case 4:
            // color = 'ff4d4d'
            color = '4d4dff'
            break
          case 5:
            // color = 'ff0000'
            color = '0000ff'
            break
          case 6:
          case 7:
            // color = 'cc0000'
            color = '0000cc'
            break
          case 8:
          case 9:
          case 10:
            // color = '990000'
            color = '000099'
            break
          //超過10最黑
          default:
            // color = '4d0000'
            color = '00004d'
            break
        }
      }
      let highlight = ""
      if (block.is_highlight_start) {
        highlight += "border-top:2px groove cyan;"
      }
      if (block.is_highlighted) {
        // auto_accept_count use thick left border which is in higher priority 
        if (!block.auto_accept_count) {
          highlight += "border-left:2px groove cyan;"  
        }
        highlight += "border-right:2px groove cyan;filter:opacity(0.9);"
      }
      if (block.is_highlight_end) {
        highlight += "border-bottom:2px groove cyan;"
      }
      let auto_accept_border = ""
      if (block.auto_accept_count) {
        let auto_color = block.overlays <= block.auto_accept_count?"#00fc00":"#fc0000"
        auto_accept_border = "border-left:"+(block.auto_accept_count*2)+"px inset "+auto_color+";"
      }
      return 'height:'+block.duration+'px;background-color:#'+color+';'+highlight+auto_accept_border
    },
  },
  computed: {
    
  },
  created() {
    
  },
  mounted () {
    
  },
  watch:{
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.holder-left {
  float:left;
  padding-right:0px;
  border-top-style:ridge;
  border-left-style:ridge;
  border-bottom-style:ridge;
}
.holder-right {
  float:left;
  padding-left: 0px;
  border-top-style:ridge;
  border-right-style:ridge;
  border-bottom-style:ridge;
}
.hour-block {
  height:60px;
  line-height: 60px;
  text-align:center;
  border-bottom-style:dotted;
}
.tblock:hover {
  background-color:cornsilk!important;
}
</style>
